import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import SupplierSearch from '@/src/javascripts/settings/suppliers/SupplierSearch.vue'

$(document).on('turbo:load turbo:render', () => {
  const supplierIndex = document.querySelector('#supplier-index')
  if (supplierIndex && !supplierIndex.__vue_app__) {
    createApp({ components: { BaseAlert, SupplierSearch } }).mount(supplierIndex)
  }
})
